
import React from 'react';
import { Editor } from '@tiptap/react';
import { Undo, Redo } from 'lucide-react';
import EditorButton from '../buttons/EditorButton';
import EditorButtonGroup from '../buttons/EditorButtonGroup';

interface HistoryButtonsProps {
  editor: Editor;
}

const HistoryButtons = ({ editor }: HistoryButtonsProps) => {
  return (
    <EditorButtonGroup>
      <EditorButton 
        onClick={() => editor.chain().focus().undo().run()}
        disabled={!editor.can().undo()}
        title="Annuler"
        icon={<Undo className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().redo().run()}
        disabled={!editor.can().redo()}
        title="Rétablir"
        icon={<Redo className="h-4 w-4" />}
      />
    </EditorButtonGroup>
  );
};

export default HistoryButtons;
